import React from "react";
import LinearGradient from "react-native-linear-gradient";
import { StyleSheet, View, Text, Pressable, ScrollView } from "react-native";

//Custom Imports
import { vh } from "@utils/scale";
import color from "@constants/color";
import analytics from "@services/analytics";
import { fontFamily } from "@utils/styles";
import Next from "@assets/svg/Navigation/Next";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import { VACATION_EVENTS } from "@constants/analyticsEventsCT";

export const SeeRulesButton = ({
  navigation = {},
  terms_and_conditions = {},
}) => {
  const { detailed } = terms_and_conditions;

  const viewTnC = () => {
    analytics.trackEvent(VACATION_EVENTS.LEAVE_RULES);
    navigation.navigate("VacationTnC");
  };

  return (
    <Pressable onPress={viewTnC} style={styles.rulesContainer}>
      <Text style={styles.rulesText}>
        {detailed?.label ? detailed?.label : ""}
      </Text>
      <Next strokeColor={color.primary} />
    </Pressable>
  );
};

const InitialVacationPolicy = ({
  navigation = {},
  terms_and_conditions = {},
}) => {
  const { cms_id = "" } = terms_and_conditions;
  return (
    <View style={styles.container}>
      <ScrollView
        scrollEnabled={false}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
      >
        <FetchCMSEntity id={cms_id} type="PAGE" isPaddingVertical={false} />
      </ScrollView>
      <LinearGradient
        colors={[
          "rgba(247, 247, 247, 0)",
          color.primaryBg,
          color.primaryBg,
          color.primaryBg,
        ]}
        style={styles.viewContainer}
      >
        <SeeRulesButton
          terms_and_conditions={terms_and_conditions}
          navigation={navigation}
        />
      </LinearGradient>
    </View>
  );
};

export default InitialVacationPolicy;

const styles = StyleSheet.create({
  container: {
    marginTop: 12,
    marginHorizontal: 16,
    backgroundColor: color.white,
    borderRadius: 8,
    maxHeight: vh(480),
    minHeight: vh(200),
    overflow: "hidden",
  },
  rulesContainer: {
    flexDirection: "row",
    marginTop: 16,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: "#E5E5E5",
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderWidth: 1,
    paddingVertical: 7,
    paddingHorizontal: 10,
    borderRadius: 20,
  },
  rulesText: {
    fontSize: 14,
    fontFamily: fontFamily.regular,
    color: color.lightBlack,
    lineHeight: 24,
    marginEnd: 11,
  },
  viewContainer: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    alignItems: "center",
    paddingTop: 30,
    paddingBottom: 16,
    borderBottomEndRadius: 8,
    borderBottomStartRadius: 8,
    zIndex: 100,
  },
});
